// boundaries/SentryErrorBoundary.jsx
import * as Sentry from "@sentry/react";

export default function SentryErrorBoundary({
  children,
  fallback = null,
  boundaryName = "unknown",
}) {
  const defaultHandler = ({ error, resetError }) => (
    <div style={{ padding: "20px", color: "red" }}>
      <h2>Oops! Something went wrong.</h2>
      <p>Error: {error}</p>
      <button onClick={resetError}>Try Again</button>
    </div>
  );

  return (
    <Sentry.ErrorBoundary
      fallback={fallback || defaultHandler}
      beforeCapture={(scope) => {
        scope.setTag("boundary", boundaryName);
        scope.setExtra("timestamp", Date.now());
      }}
      onError={(error, componentStack, eventId) => {
        console.log("Captured error:", error, componentStack, eventId);
      }}
      // showDialog={true} // optional
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
